/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AppRoutes, RouteParams } from "src/app/constants";
import { EventContentsPage } from "./event-contents.page";

const routes: Routes = [
  {
    path: "",
    component: EventContentsPage,
  },
  {
    path: AppRoutes.add,
    loadChildren: () => import("../event-content-form/event-content-form.module").then(m => m.EventContentFormPageModule),
  },
  {
    path: `:${RouteParams.contentId}`,
    loadChildren: () => import("../event-content-detail/event-content-detail.module").then(m => m.EventContentDetailPageModule),
  },
  {
    path: `:${RouteParams.contentId}/${AppRoutes.edit}`,
    loadChildren: () => import("../event-content-form/event-content-form.module").then(m => m.EventContentFormPageModule),
  },
  {
    path: `:${RouteParams.contentId}/${AppRoutes.add}`,
    loadChildren: () => import("../event-form/event-form.module").then(m => m.EventFormPageModule),
  },
  {
    path: `:${RouteParams.contentId}/:${RouteParams.eventId}`,
    loadChildren: () => import("../event-form/event-form.module").then(m => m.EventFormPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EventContentsPageRoutingModule {}
